"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileChoiceCardsWidget = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var get_member_1 = require("../../../api/calls/loyalty/get_member");
var ProfileChoiceCardsWidget = function () {
    var _a;
    var dispatch = (0, react_redux_1.useDispatch)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _b = (0, react_1.useState)(null), loyaltyMember = _b[0], setLoyaltyMember = _b[1];
    (0, react_1.useEffect)(function () {
        (0, get_member_1.loyalty_member)({
            cell_number: user.cell_number,
        }).then(function (response) {
            if (response.success) {
                setLoyaltyMember(response.content);
            }
            else {
                //   dispatch(setMessageModal({ title: "Something went wrong!", messages: [response.message] }));
            }
        });
    }, [user]);
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4 p-4 border border-borders rounded-lg" },
        react_1.default.createElement("div", { className: "flex flex-row" },
            react_1.default.createElement("div", { className: "flex-1" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Virtual Choice Card", size: "large", textColor: "text-black" })),
            react_1.default.createElement("div", { className: "flex flex-row gap-4" })),
        react_1.default.createElement("div", { className: "" }, loyaltyMember ? (react_1.default.createElement("div", { className: "mb-2 pt-2 flex flex-row gap-4 items-center" },
            react_1.default.createElement("div", { className: "flex-1 flex flex-col" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: (_a = loyaltyMember === null || loyaltyMember === void 0 ? void 0 : loyaltyMember.card) === null || _a === void 0 ? void 0 : _a.number, bold: true, textColor: "text-black" })))) : (react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "You do not have a choice card linked." })))));
};
exports.ProfileChoiceCardsWidget = ProfileChoiceCardsWidget;
